import { Router } from 'vue-router'
import { setTitleByRoute } from '@/utils'

export function createPageTitleGuard(router: Router) {
  router.afterEach((to) => {
    setTitleByRoute(to)
  })
}
